import { NcwOnboardingSlideDapps } from '@capsicum/common';
import { useOnboardingSlidesTranslations } from '@capsicum/features/nc-onboarding/web';
import { type FC } from 'react';

import * as S from './components.styled';
import { Shell } from './Shell';

export const ThirdPoblanoPage: FC<{ goBack: () => void; next: () => void }> = ({ goBack, next }) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell goBack={goBack} proceed={next}>
			<S.ImageWrapper>
				<S.Image
					alt="thirdNCW-slide-image"
					data-testid="onboarding-third-slide-image"
					src={NcwOnboardingSlideDapps}
				/>
			</S.ImageWrapper>

			<S.HeadlineText>{$t('onboarding.ncw.two.title')}</S.HeadlineText>
			<S.Dropline>{$t('onboarding.ncw.two.description')}</S.Dropline>
		</Shell>
	);
};
